import React from 'react'

function Status() {
  return (
    <div>
        <h1>Status:OK</h1>
    </div>
  )
}

export default Status